import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=a15066aa&scoped=true"
import script from "./ProductDisplay.vue?vue&type=script&lang=js"
export * from "./ProductDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductDisplay.vue?vue&type=style&index=0&id=a15066aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15066aa",
  null
  
)

export default component.exports